import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

// Sprint 39 — Professional SaaS color injection.
// Pill (rounded-full) shape, full-tint backgrounds, uppercase tracked text.
// Solid `default` keeps brand teal for primary chips; tinted variants use a
// 15% background of their tone color with the saturated foreground.
const badgeVariants = cva(
  "inline-flex items-center rounded-full border border-transparent px-2.5 py-0.5 text-xs font-public-sans font-bold uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground hover:bg-primary/90",
        secondary:
          "bg-secondary/10 text-foreground dark:bg-secondary/20",
        destructive:
          "bg-destructive/15 text-destructive dark:bg-destructive/20",
        outline:
          "border-outline-variant bg-transparent text-foreground",
        success:
          "bg-success/15 text-success dark:bg-success/20",
        warning:
          "bg-warning/15 text-warning dark:bg-warning/20",
        info:
          "bg-accent/15 text-accent dark:bg-accent/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
